module.exports = __webpack_public_path__ + "static/img/1-7.e519e1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/science/1-7.png
// module id = S/JJ
// module chunks = 15